<template>
  <div>
    <div class="page-header">
      <v-layout row align-center>
        <v-icon x-large color="primary">mdi-golf</v-icon>
        <h1 class="page-title">Association</h1>
      </v-layout>
    </div>
    <v-expansion-panels>
      <v-expansion-panel>
        <v-expansion-panel-header class="label">Board Members
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row>
            <v-col cols="12">
              <v-data-table
                :hide-default-footer="hideFooter"
                :headers="headers"
                :items="boardMembers"
                item-key="board.boardId"
                :items-per-page="itemsPerPage"
              >
                <template v-slot:header v-if="priviledged">
                  <v-row>
                    <v-col cols="3">
                      <div class="add-button">
                        <v-btn
                          outlined
                          @click="onEdit(0)"
                        >
                          <v-icon left>mdi-plus</v-icon>Add
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </template>

                <template v-if="priviledged" v-slot:item.edit="{ item }">
                  <div class="button">
                    <v-btn
                      outlined
                      @click="onEdit(item.boardId)"
                    >
                      <v-icon left>mdi-pencil</v-icon>Edit
                    </v-btn>
                  </div>
                </template>
                <template v-if="priviledged" v-slot:item.delete="{ item }">
                  <div class="button">
                    <v-btn
                      outlined
                      @click="onDelete(item.boardId)"
                    >
                      <v-icon left>mdi-delete</v-icon>Delete
                    </v-btn>
                  </div>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header class='label'>Mission Statement
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card>
            <v-card-text><div v-html="association.mission"></div></v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-row justify="center">
      <v-dialog v-model="dialog" persistent max-width="290">
        <v-card>
          <v-card-title class="headline"
            >Delete the selected<br />board member?</v-card-title
          >
          <v-card-text>{{ title }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn outlined text @click="dialog = false"
              >No</v-btn
            >
            <v-btn outlined text @click="deleteMember"
              >Yes</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <statusalert ref="alert" returnUrl="/news"></statusalert>
  </div>
</template>

<script>
import AssociationService from '../../services/api/AssociationService.js'
import BoardService from '../../services/api/BoardService.js'
import store from '@/store/index.js'
import router from '@/router/index.js'
import statusalert from '../../components/StatusAlert'

export default {
  name: 'Association',
  components: {
    statusalert
  },
  store: store,
  data() {
    return {
      association: {},
      boardId: 0,
      boardMembers: [],
      dialog: false,
      headers: [
        {
          text: '',
          align: 'start',
          sortable: true,
          value: 'edit'
        },
        {
          text: '',
          align: 'start',
          sortable: true,
          value: 'delete'
        },
        {
          text: 'Title',
          align: 'start',
          sortable: true,
          value: 'title'
        },
        {
          text: 'Member',
          align: 'start',
          sortable: true,
          value: 'member'
        },
        {
          text: 'Phone',
          align: 'start',
          sortable: true,
          value: 'phone'
        },
        {
          text: 'Email',
          align: 'start',
          sortable: true,
          value: 'email'
        }
      ],
      hideFooter: true,
      itemsPerPage: 99,
      title: ''
    }
  },

  created() {
    this.fetchAssociation()
    this.fetchBoard()
  },

  computed: {
    priviledged() {
      return (
        this.$store.getters.getAdministrator || this.$store.getters.getProShop
      )
    }
  },

  methods: {
    deleteMember() {
      this.dialog = false
      store.commit('isLoading')
      if (this.boardId > 0) {
        BoardService.delete(this.boardId)
          .then(result => {
            this.result = {
              isValid: true,
              statusCode: result.status,
              errors: ['Deleted board member']
            }
          })
          .catch(error => {
            console.log(error)
            this.result = {
              isValid: false,
              statusCode: 404,
              errors: ['Failed to delete board member']
            }
          })
          .finally(() => {
            store.commit('notLoading')
            this.$refs.alert.displayResult(this.result)
            this.fetchBoard()
          })
      }
    },

    onDelete(id) {
      this.dialog = true
      const member = this.boardMembers.find(n => n.boardId === id)
      this.title = ''
      this.boardId = 0
      if (member) {
        this.boardId = id
        this.title = member.member
      }
    },
    onEdit(id) {
      router.push('/association/board/' + id)
    },
    fetchAssociation() {
      store.commit('isLoading')
      this.faqs = []
      AssociationService.get(1)
        .then(association => {
          this.association = association
        })
        .catch(error => console.log(error))
        .finally(() => {
          store.commit('notLoading')
        })
    },
    fetchBoard() {
      console.log()
      BoardService.get()
        .then(board => {
          this.boardMembers = board
        })
        .catch(error => console.log(error))
        .finally(() => {
          store.commit('notLoading')
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.label {
  margin-left: 10px;
  padding: 5px;
  font: bolder;
}
tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.05);
}
</style>
